




import { defineComponent, onBeforeUnmount, ref } from "@vue/composition-api";
import emitter from "@/lib/emitter";
import { EVENTS } from "@/const";
import ConfirmLiveChatInvitation from "@/components/Confirms/ConfirmLiveChatInvitation";
import { ModalsControllerEventData } from "./types";

export default defineComponent({
  name: "ModalsController",
  components: { ConfirmLiveChatInvitation },
  setup() {
    const component = ref<string | null>(null);
    const componentProps = ref<any>(null);

    const onShow = (data?: ModalsControllerEventData) => {
      if (!data) return;
      component.value = data.component;
      componentProps.value = data.props;
    };

    const close = () => {
      component.value = null;
      componentProps.value = null;
    };

    emitter.on<ModalsControllerEventData>(EVENTS.MODAL_CONTROLLER_SHOW, onShow);

    onBeforeUnmount(() => {
      emitter.off<ModalsControllerEventData>(EVENTS.MODAL_CONTROLLER_SHOW, onShow);
    });

    return {
      component,
      componentProps,
      close,
    };
  },
});
